module.exports = __webpack_public_path__ + "media/club_product_v2/GG-Icon-014d5530.png";